import { observer } from "mobx-react";
import type React from "react";
import { Navigate } from "react-router-dom";

import { GENERIC_ROUTES, RESULT_PAGE_ROUTES } from "constants/routes";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { TestType } from "constants/exam-constants";
import { useScheduledTests } from "hooks/useScheduledTests";
import type { ScheduledTestScoreDetail } from "models/exam/ScheduledTest";

export const ResultsPage: React.FC = observer(() => {
  const { scheduledTestScore } = useScheduledTests();

  // Obtain url to redirect to when accessing base path based on loaded test
  const getResultsMainUrl = ({ type: testType }: ScheduledTestScoreDetail): string => {
    const resultsPathUrl = RESULT_PAGE_ROUTES.TEST_TYPE_RESULTS_LIST;
    return buildUrlWithPathParams(resultsPathUrl, {
      testType: testType === TestType.FREEBIE_TEST ? TestType.INTAKE_TEST : testType,
    });
  };

  return (
    <Navigate
      to={!scheduledTestScore ? GENERIC_ROUTES.HOME_PAGE : getResultsMainUrl(scheduledTestScore)}
      replace
    />
  );
});
